import React, { useEffect, useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { createOrderStatus,createEventdetails,createleadsdetails, createOrderHistory ,createUserPrivilegeCrm,createTaskTable} from "../../../api/api";
import { useTranslation } from "react-i18next";

const DbUpdates = () => {
  const { t } = useTranslation();
const [showModal, setShowModal] = useState(false); // State to control modal visibility
 const [passwordInput, setPasswordInput] = useState("");
  const [accessGranted, setAccessGranted] = useState(false);
const passwordRef = useRef<HTMLInputElement>(null);// for autofocus on password input

   const HARD_CODED_PASSWORD = "12345"; // hard coded password 

    // Show modal on component mount
  useEffect(() => {
    setShowModal(true);
  }, []);

  //check password
    const handleSubmit = () => {
    if (passwordInput === HARD_CODED_PASSWORD) {
      setAccessGranted(true);  // show the page
      setShowModal(false);     // close modal
    } else {
      alert(t("Incorrect password!"));
      setPasswordInput("");    // clear input
    }
  };

  // Handle "Enter" key press in password input
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  // Clear input field
  const handleClear = () => {
    setPasswordInput('');
  };

  //auto focus on password input when modal opens
  useEffect(() => {
  if (showModal) {
    // small timeout ensures modal is fully rendered
    setTimeout(() => {
      passwordRef.current?.focus();
    }, 100);
  }
}, [showModal]);


  //  order status
const handleCreateOrderStatus = async () => {
  try {
    const res = await createOrderStatus(); // call your API
    alert(res.message ||  t("Order Status updated successfully!"));
    console.log("Order Status Response:", res);
  } catch (error: any) {
    alert(t("Can't create, Order Status table already exists!"));
    console.error(error);
  }
};

// Event Details
const handleCreateEventDetails = async () => {
  try {
    const res = await createEventdetails();
    alert(res.message || t("Event Details updated successfully!"));
    console.log("Event Details Response:", res);
  } catch (error: any) {
    alert(t("can't create, Event Details table already exists!"));
    console.error(error);
  }
};

// Leads Details
const handleCreateLeadsDetails = async () => {
  try {
    const res = await createleadsdetails();
    alert(res.message || t("Leads Details updated successfully!"));
    console.log("Leads Details Response:", res);
  } catch (error: any) {
    alert(t("can't create, Leads Details table already exists!"));
    console.error(error);
  }
};
//orderhistory
const handleCreateOrderHistory = async () => {
  try {
    const res = await createOrderHistory();
    alert(res.message || t("Order History updated successfully!"));
    console.log("Order History Response:", res);
  } catch (error: any) {
    alert(t("can't create, Order History table already exists!"));
    console.error(error);
  }
};

//userivilege crm
const handleCreateUserPrivilege = async () => {
  try {
    const res = await createUserPrivilegeCrm();
    alert(res.message || t("Order History updated successfully!"));
    console.log("Order History Response:", res);
  } catch (error: any) {
    alert(t("can't create, Order History table already exists!"));
    console.error(error);
  }
};

//task table
const handleCreateTaskTable = async () => {
  try {
    const res = await createTaskTable();
    alert(res.message || t("Task Table updated successfully!"));
    console.log("Task Table Response:", res);
  } catch (error: any) {
    alert(t("can't create, Task Table already exists!"));
    console.error(error);
  }
};

const handleCloseModal = () => {
  setShowModal(false);
  setPasswordInput("");
  setAccessGranted(false); 
};

   return (
    <div className="page-wrapper">
      <div className="container-fluid">

     
        {/* Password Modal */}
       <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Enter Password")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
           ref={passwordRef}
            type="password"
            className="form-control"
            placeholder={t("Enter your password")}
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClear}>
            {t("Clear")}
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {t("Submit")}
          </Button>
        </Modal.Footer>
      </Modal>

       {/* Password modal */}
     
      {accessGranted && (
        <div className="card">
          <div className="card-body pb-0">
            <h4 className="fw-semibold mb-3">{t("Db Updates")}</h4>
            <div className="row">

              {/* order_status */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("Order Status")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                   <div>
                    <button
                        type="button"
                        className="btn btn-primary"   
                          onClick={handleCreateOrderStatus} // call the async handler
                    >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
            {/* order_status */}

             {/* order_history */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("Order History")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                    <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleCreateOrderHistory}
                        >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
             {/* order_history */}

             {/* event_details */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("Event Details")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                    <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                          onClick={handleCreateEventDetails}
                    >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
               {/* event_details */}

              {/* leads_details */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("Leads Details")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                    <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                          onClick={handleCreateLeadsDetails}
                    >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
             {/* leads_details */}

             {/*userPrivilegecrm */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("User Privilege CRM")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                    <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleCreateUserPrivilege}
                        >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
             {/* userPrivilegecrm */}

              {/* task_table */}
              <div className="col-lg-4 col-md-6 d-flex">
                <div className="card border shadow-none flex-fill mb-3">
                  <div className="card-body d-flex justify-content-between flex-column">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h6 className="fw-semibold">{t("Task Table")}</h6>
                        
                      </div>
                      <p></p>
                    </div>
                    <div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleCreateTaskTable}
                        >
                        {t("Click")}
                    </button>
                    </div>

                  </div>
                </div>
              </div>
             {/* task_table */}

             </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default DbUpdates;
